// extracted by mini-css-extract-plugin
export default {"container":"elementScrollControl_container__C+agD","hiddenSpace":"elementScrollControl_hiddenSpace__6RX2-","stickyPart":"elementScrollControl_stickyPart__1l6+F"};